import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'
import { withPrefix } from 'gatsby'

const StyledWrapper = styled.section`
  background-color: ${ ({ scBackgroundColor }) => scBackgroundColor } ;
  color: ${ ({ theme }) => theme.colors.white } ;
`

const StyledContainer = styled(ArBaseContainer)`
  position: relative;
  padding-bottom: 40px;
  padding-top: 30px;

  ${ media.tablet`
    padding-top: 80px;
    padding-bottom: 80px;
  ` }

  ${ media.desktop`
    padding-top: 100px;
    padding-bottom: 100px;
  ` }
`

const StyledTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.18;
  position: relative;
  text-align: center;

  ${ media.tablet`
    font-size: 4.5rem;
  ` }
`

const StyledButton = styled(ArBaseButton)`
  position: relative;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;

  ${ media.tablet`
    margin-top: 30px;
  ` }
`

const ImageLeft = styled(ArBaseImage)`
  position: absolute;
  bottom: -20px;
  left: 5px;
  width: 31%;
`

const ImageRight = styled(ArBaseImage)`
  position: absolute;
  top: -24px;
  right: 26px;
  width: 31%;
`

class ArCTASection extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    cta: PropTypes.object,
    scBackgroundColor: PropTypes.string,
  }

  render () {
    const { title, cta, scBackgroundColor } = this.props
    return (
      <StyledWrapper scBackgroundColor={scBackgroundColor}>
        <StyledContainer>
          <ImageLeft src={withPrefix('img/ArCTASection1.svg')} />
          <ImageRight src={withPrefix('img/ArCTASection2.svg')} />
          <StyledTitle>{ title }</StyledTitle>
          <StyledButton label={cta.label} to={cta.url} variant="white"></StyledButton>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArCTASection
